/* eslint-disable no-nested-ternary */
import { useState } from "react";
import LocationIcon from "@mui/icons-material/PlaceOutlined";

import { ListItemIcon } from "@mui/material";
import NitroFilter from "../NitroFilter";
import { sortByField } from "../../utils/Sort";
import NitroService from "../../utils/nitro.service";
import FacilityIcon from "../../svg/facilityIcon.svg?react";
import CityIcon from "../../svg/cityIcon.svg?react";

const LocationExpandedFilter = ({
  value,
  setValue,
  config,
  isMobile,
  disabled,
  variant,
}: {
  value: string;
  setValue: (type: string, value: string) => void;
  config?: {
    customPaper?: boolean;
    shadow?: boolean;
    opaque?: boolean;
    autoFocus?: boolean;
    inputRef?: React.MutableRefObject<any> | null;
    valueRequired?: boolean;
  };
  isMobile?: boolean;
  disabled?: boolean;
  variant?: "standard" | "outlined" | "filled";
}) => {
  const finalConfig = { ...config, hideDropdownIcon: true };
  const [options, setOptions] = useState<
    { label: string; value: string; type: string }[]
  >([]);

  const getRecords = async (v: string) => {
    const records = await NitroService.getLocationExpanded(v);

    const sorted = [
      ...sortByField(
        records.filter((r) => r.type === "facility"),
        "name",
        "ASC",
      ),
      ...sortByField(
        records.filter((r) => r.type === "city"),
        "name",
        "ASC",
      ),
    ];
    const iconStyle = { width: 40, height: 40 };
    const newOptions = [
      ...sorted.map((r) => {
        return {
          label: r.name || "",
          value: r.name || "",
          type: r.type || "",
          icon:
            r.type === "facility" ? (
              <FacilityIcon style={iconStyle} />
            ) : r.type === "city" ? (
              <CityIcon style={iconStyle} />
            ) : null,
        };
      }),
    ];

    setOptions(newOptions);

    return newOptions;
  };

  return (
    <NitroFilter
      placeholder="City or Facility name"
      size="small"
      data={{
        getRecords,
      }}
      Icon={<LocationIcon style={{ color: "#383838" }} />}
      value={value}
      setValue={(val: string) => {
        // clear action
        if (val === "") {
          setValue("clear", "");
        }
        const obj = options.find((r) => r.value === val);
        if (obj) {
          setValue(obj?.type, val);
        }
      }}
      config={finalConfig}
      isMobile={isMobile}
      disabled={disabled}
      variant={variant}
      autocompleteOptions={{
        renderOption: (params: any, option: any) => {
          // MUI includes "key" in params; must be pulled out to avoid the spread-key React warning
          const { key, ...optionProps } = params;
          return (
            <li
              key={key}
              {...optionProps}
              style={{
                ...optionProps.style,
                minHeight: 20,
                padding: "6px 15px",
              }}
            >
              <ListItemIcon>{option.icon}</ListItemIcon>
              <div
                style={{ display: "flex", flexDirection: "column", gap: 0 }}
              >
                <div style={{ fontSize: 13 }}>{option?.label || ""}</div>
                <div
                  style={{
                    paddingLeft: 15,
                    fontSize: 10,
                    textTransform: "uppercase",
                    color: "#878787",
                  }}
                >
                  {option?.type || ""}
                </div>
              </div>
            </li>
          );
        },
        filterOptions: (records: any) => {
          return records;
        },
      }}
    />
  );
};

export default LocationExpandedFilter;
